module.exports = __webpack_public_path__ + "img/Accrete-D3-logo-dark.1d31657e.png";